import { gql } from "@apollo/client";

export const SAVE_EMPLOYEE = gql`
  mutation saveEmployee($input: SaveEmployeeInput) {
    saveEmployee(input: $input) {
      commandId
    }
  }
`;

export const DELETE_EMPLOYEE = gql`
  mutation deleteEmployee($input: DeleteEmployeeInput) {
    deleteEmployee(input: $input) {
      commandId
    }
  }
`;
